import React from 'react'
import { useState } from 'react'
import ScannerWrap from '../../../../scanner/ScannerWrap'
import { useEffect } from 'react'
import { setValueForm } from '../../../../../helpers/form/FormHelper'
import PackingConfirmGetSeriesData from '../PackingConfirmGetSeriesData'

const PackingConfirmFieldScaner = ({ valueScan, setValueScan, reset, setReset, header, goodFromBd, setGoodFromBd }) => {

    // const [loading, setLoading] = useState(false)
    // const [error, setError] = useState('')

  return (
    <div className='seriesRead'>
        <h4>
            {header}
        </h4>

        <ScannerWrap
            setResultText={e => {
                // setScanResultTemp(e)
                // setScannedGood(e)
                setValueScan(e)
            }}
            reset={reset}
            setReset={setReset}
        />


        {
            valueScan ? 
                <div className='success'>
                    Результат сканування: {valueScan}
                </div>
            : ''
        }

        {
            valueScan ?
                <>
                    <PackingConfirmGetSeriesData 
                        // goodType={goodType}
                        goodFromBd={goodFromBd}
                        setGoodFromBd={setGoodFromBd}
                        valueScan={valueScan}
                    />
                </>
            : ''
        }

    </div>
  )
}

export default PackingConfirmFieldScaner